// extracted by mini-css-extract-plugin
export default {"cls1":"OTPAdminDialog-Form_cls1__H+NO+","cls2":"OTPAdminDialog-Form_cls2__M39Mv OTPAdminDialog-Form_cls1__H+NO+"};